import React, { useEffect, useState } from 'react'
import { Navigate, useLocation, useParams } from "react-router-dom"
import { fetchCurrentUser, getUsername, isAssociateManagerOrAbove, isSenior, canViewMaintenanceDashboard, isICCSupport, canViewManagerDashboard, canViewAssetDashboard, useAuth} from './components/auth';
import { Unauthorized } from './components/common/Unauthorized';
import { isAssociate, isReadOnly, userIsSafetyTeam, isSeniorView } from "./components/auth/Auth";

export const ProtectedRoute = ({ children }) => {
    const auth = useAuth();
    const location = useLocation();
    const [restoring, setRestoring] = useState(true);

    useEffect(() => {
        let cancelled = false;
        fetchCurrentUser()
            .then(userData => {
                if (cancelled) return;
                if (userData) {
                    auth.saveUser(userData);
                } else {
                    auth.clearUser();
                }
            })
            .catch(error => {
                console.error("Failed to restore session:", error);
                if (!cancelled) {
                    auth.clearUser();
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setRestoring(false);
                }
            });

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (restoring) {
        return null;
    }

    if (sessionStorage.getItem("user") == null) {
        return <Navigate to="/login" state={{ redirectLocation: location }} replace />
    }
    return children

};

export const getViewingConditions = (id) => ({
    'homepage': true,
    'members': (isReadOnly() && !isSeniorView()) || isSenior() || isAssociateManagerOrAbove() || (id != null && id === getUsername()),
    'teams': (isReadOnly() && !isSeniorView()) || isSenior() || isAssociateManagerOrAbove() || userIsSafetyTeam(),
    'assets': (isReadOnly() && !isSeniorView()) || isAssociate() || isSenior() || isAssociateManagerOrAbove() || canViewMaintenanceDashboard() || userIsSafetyTeam(),
    'devicesubtypes': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
    'readiness': (isReadOnly() && !isSeniorView()) || isAssociate() || isSenior() || isAssociateManagerOrAbove(),
    'readinessReport': (isReadOnly() && !isSeniorView()) || isAssociateManagerOrAbove(),
    'onestop': (isReadOnly() && !isSeniorView()) || isAssociate() || isSenior(),
    // associates should be able to view their own, so we do another
    // check in the event detail page
    'events': true,
    'teamcalendar': true,
    'profile': true,
    'standdown': true,
    'forms': true,
    'documents': true,
    'maintenance': (isReadOnly() && !isSeniorView()) || canViewMaintenanceDashboard(),
    'roadblock_report': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
    'asset_problem_report': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
    'future_readiness': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove() || isSenior(),
    'support': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
    'manager_dashboard': (isReadOnly() && !isSeniorView()) || canViewManagerDashboard(),
    'asset_dashboard': (isReadOnly() && !isSeniorView()) || canViewAssetDashboard(),
    'reporting_dashboard': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
})

export const AuthorizedRoute = (props) => {
    const { id } = useParams()

    const viewingConditions = {
        'homepage': true,
        'members': (isReadOnly() && !isSeniorView()) || isSenior() || isAssociateManagerOrAbove() || (props.route === 'members' && id === getUsername()),
        'teams': (isReadOnly() && !isSeniorView()) || isSenior() || isAssociateManagerOrAbove() || userIsSafetyTeam(),
        'assets': (isReadOnly() && !isSeniorView()) || isAssociate() || isSenior() || isAssociateManagerOrAbove() || canViewMaintenanceDashboard() || userIsSafetyTeam(),
        'devicesubtypes': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
        'readiness': (isReadOnly() && !isSeniorView()) || isAssociate() || isSenior() || isAssociateManagerOrAbove(),
        'readinessReport': (isReadOnly() && !isSeniorView()) || isAssociateManagerOrAbove(),
        'onestop': (isReadOnly() && !isSeniorView()) || isAssociate() || isSenior(),
        // associates should be able to view their own, so we do another
        // check in the event detail page
        'events': true,
        'teamcalendar': true,
        'profile': true,
        'standdown': true,
        'forms': true,
        'documents': true,
        'maintenance': (isReadOnly() && !isSeniorView()) || canViewMaintenanceDashboard(),
        'roadblock_report': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
        'asset_problem_report': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
        'future_readiness': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove() || isSenior(),
        'support': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
        'manager_dashboard': (isReadOnly() && !isSeniorView()) || canViewManagerDashboard(),
        'asset_dashboard': (isReadOnly() && !isSeniorView()) || canViewAssetDashboard(),
        'reporting_dashboard': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
    }

    const viewingConditionSatisfied = viewingConditions[props.route]
    if (!viewingConditionSatisfied) {
        return <Unauthorized />
    }

    return props.children
}
